<template>
    <span class="field assumption-field">
      <input
        type="text"
        name="interest"
        v-model="displayValue"
        @blur="isInputActive = false"
        @focus="isInputActive = true"
        class="form-control form-control-assumptions">
    </span>
</template>

<script>
export default {
  name: 'rate-input',
    props: ["value"],
    data: function() {
      return {
        isInputActive: false
      }
    },
    computed: {
      displayValue: {
        get: function() {
          if (this.isInputActive) {
            // Cursor is inside the input field. unformat display value for user
            return this.value.toString()
          } else {
            // User is not modifying now. Format display value for user interface
            return this.value + ' x'
          }
        },
        set: function(modifiedValue) {
          // Recalculate value after ignoring "$" and "," in user input
          let newValue = parseFloat(modifiedValue.replace(/[^\d\.]/g, ""))
          // Ensure that it is not NaN
          if (isNaN(newValue)) {
            newValue = 0
          }
          // Note: we cannot set this.value as it is a "prop". It needs to be passed to parent component
          // $emit the event so that parent component gets it
          this.$emit('input', newValue)
        }
      }
    }
  }
</script>

<style scoped>
.field .assumption-field {
  margin: 0 0 0 400px;
}

.form-field-assumption label{
  width: 400px;
}

.form-field .form-field-assumption {
    margin: 0 0 0;
}

.form-field {
  margin: 0 0 20px;
}

.form-control-assumptions {
  width: 47%;
}
</style>
